module.exports = __webpack_public_path__ + "img/1. MICROLINES CUT - START KIT - 5 PACK.jpg";